// 假设你有一个 Vue 实例（通常是 main.js 中的 app）
import Vue from "vue";

// 创建一个 Vue 实例来管理 toast 组件
let toastInstance = null;

function showToast(message, duration = 5000) {
  // 如果已经有一个 toast 实例正在显示，则销毁它
  if (toastInstance) {
    toastInstance.$destroy();
    document.body.removeChild(toastInstance.$el);
    toastInstance = null;
  }

  // 创建新的 toast 实例
  const ToastComponent = Vue.extend(require("../components/Toast.vue").default);
  toastInstance = new ToastComponent({
    propsData: {
      message: message,
      visible: true,
    },
  });

  // 挂载到 body 上
  toastInstance.$mount(document.createElement("div"));
  document.body.appendChild(toastInstance.$el);

  // 设置超时隐藏 toast
  setTimeout(() => {
    toastInstance.visible = false;
  }, duration);

  // 监听 visible 的变化，当变为 false 时销毁实例
  toastInstance.$watch("visible", (val) => {
    if (!val) {
      setTimeout(() => {
        toastInstance.$destroy();
        document.body.removeChild(toastInstance.$el);
        toastInstance = null;
      }, 5000); // 等待动画结束后再销毁
    }
  });
}

export default {
  showToast,
};



// WEBPACK FOOTER //
// ./src/utils/toastService.js